import React, { useEffect, useState } from 'react';

import { Autocomplete, MenuItem, Select } from 'shell/components';

const SingleSelectQuestion = ({ id, question, itemList, defaultItem, review, handleSelected }) => {
    const [selectedItem, setSelectedItem] = useState({ key: '', value: 'Select' });

    const handleChangeAutocomplete = (_, option) => {
        handleSelectedItem(option);
    };

    const handleChangeSelect = (e) => {
        const option = itemList.find(({ key }) => key === e.target.value);
        handleSelectedItem(option);
    };

    const handleSelectedItem = (data) => {
        setSelectedItem(data);
        handleSelected(data);
    };

    useEffect(() => {
        if (defaultItem) setSelectedItem(defaultItem);
    }, [defaultItem]);

    if (['time-zone', 'country'].includes(id)) {
        return (
            <Autocomplete
                clearable={false}
                disabled={review}
                label={question}
                options={itemList}
                virtualized
                value={selectedItem}
                onChange={handleChangeAutocomplete}
            />
        );
    }

    return (
        <Select
            disabled={review}
            displayEmpty
            label={question}
            labelId={id}
            value={selectedItem.key}
            onChange={handleChangeSelect}
        >
            {itemList.map(({ key, value }) => (
                <MenuItem key={key} value={key}>
                    {value}
                </MenuItem>
            ))}
        </Select>
    );
};

export default SingleSelectQuestion;
